// Here is where you can put async operations.
// See the Vuex official docs for more information.

// ...

// src/store/actions.js

//  获取经销商人员的【经销商员工类型】
/* 
经销商销售人员   40
经销商商务人员	 20
经销商销技术人员 30 
*/
export const GET_USER_Staff_Type = async ({ commit, state, rootState }) => {
    try {
        console.log('Action 开始获取');
        
        // 🔑 注意：如果 user 信息不在当前模块 state 里，可能需要 rootState.user
        // 假设 user 在根 state 里：
        if (!state.user && !rootState.user) { 
            commit("SET_STAFF_TYPE", -1);
            return;
        }

        // 优先从 rootState 拿（如果是模块），否则从 state 拿（如果是根）
        const user = state.user || rootState.user;
        const userid = user.userId;

        if (!userid) {
            commit("SET_STAFF_TYPE", -1);
            return;
        }

        let url = `api/AccountStaff/GetAccountStaffType?userId=${userid}`;
        let res = await rt.get(url); // 🔹 这里可以 await

        console.log('Action 接口返回:', res);
        
        if (res) {
            commit("SET_STAFF_TYPE", res); // 🔹 请求完成后，调用同步 mutation
        } else {
            commit("SET_STAFF_TYPE", -1);
        }
    } catch (error) {
        console.error('获取用户配置失败:', error);
        commit("SET_STAFF_TYPE", -1);
    }
};


// WEBPACK FOOTER //
// ./src/store/actions.js